<script>
    import { eventBus } from "../core/event-bus-store.js";
    import {mediaUrlStore} from "../core/app-store.js";

    export let items = [];
    export let tenantKey = '';

</script>

<style>
    .bento-gallery {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5rem;
    }

    .gallery-item {
        position: relative;
        aspect-ratio: 1;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.3s ease;
    }

    .gallery-item:hover {
        transform: scale(1.03);
    }
    .gallery-item:hover .item-content {
        opacity: 0.2;
    }

    .gallery-item img,
    .gallery-item video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .item-content {
        display: flex;
        flex-direction: column;
        gap: .5em;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
        color: white;
        font-size: .9rem;
        transition: opacity .2s ease;
    }

    .item-title {
        font-family: PT Mono, sans-serif;
    }

    .item-text {
        opacity: 0.9;
        line-height: 1.35;
    }

    /* Responsive adjustments */
    @media (max-width: 640px) {
        .bento-gallery {
            grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
            gap: 20px;
            padding: 0 1.5rem;
        }
        .item-content {
            padding: .25rem;
        }
        .item-text {
            font-size: 0.8rem;
            line-height: 1.2;
        }
    }
</style>

<div class="bento-gallery">
    {#each items as item}
        <div class="gallery-item"
             on:click={() => eventBus.set([{event: 'openFullscreen', payload: {media: item}}])}
             on:keydown={(e) => e.key === 'Enter' && eventBus.set([{event: 'openFullscreen', payload: {media: item}}])}
             role="button"
             tabindex="0">
            {#if item.type === 'photo'}
                <img src="{$mediaUrlStore}{item.ref || tenantKey}{item.url}"
                     alt={item.title}
                     loading="lazy"
                     decoding="async">
            {:else if item.type === 'video'}
                <video controls preload="none">
                    <source src="{$mediaUrlStore}{item.ref || tenantKey}{item.url}" type="video/mp4">
                    <track kind="captions">
                </video>
            {/if}
            
            {#if item.title || item.text}
                <div class="item-content">
                    {#if item.title}
                        <div class="item-title label">{item.title}</div>
                    {/if}
                    {#if item.text}
                        <div class="item-text hide-on-mobile">{item.text}</div>
                    {/if}
                </div>
            {/if}
        </div>
    {/each}
</div> 
